import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { ActualCuttingService } from "../../../services/index";
import { PrintData } from "../../master/print/print";

@Component({
  selector: "addEditPurchaseOrder",
  templateUrl: "./addEditActualCutting.html",
})
export class AddEditActualCutting {
  row: any;
  data: any;
  designdata: any = {};
  acdata: any = {
    party_code: "UNIT 1",
    party_name: "SKT CLOTHING CO",
    totalmtr: 0,
    totalamt: 0,
  };
  qualityList: any;
  typeList: any;
  colorList: any;
  printData;
  codeList: any;
  currentSlide: boolean = true;
  widthList: any[];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };

  designList = [
    {
      shade: "",
      meter: 0,
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      totmtrs: 0,
      card_no: 0
    },
  ];
  acList: any = [];
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    if (_.isEmpty(val)) {
      let row: any = {};
      row.tabevent = new EventEmitter();
      let tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD CUTTING DETAILS",
          title: "ADD CUTTING DETAILS",
          tabParent: "PURCHASE",
          mode: "Add",
          data: row,
          name: "ADD CUTTING DETAILS",
        },
      };
      this._params = tabObj;
      val = this._params;
      this.mode = tabObj.params.mode;
      this.saveEvent = row.tabevent;
      let designdata = Object.assign({}, tabObj.params["data"]);
      this.acdata = designdata;
    } else {
      this._params = val;
      this.mode = val["mode"];
      this.saveEvent = val["data"].tabevent;
      let designdata = Object.assign({}, val["data"]);
      this.acdata = designdata;

      let cp_date = designdata["cp_date"].split("-");
      if (cp_date[2].split("").length == 4) {
        this.acdata.cu_date = cp_date[2] + "-" + cp_date[1] + "-" + cp_date[0];
      }

      let wo_date = designdata["wo_date"].split("-");
      if (wo_date[2].split("").length == 4) {
        this.acdata.wo_date = wo_date[2] + "-" + wo_date[1] + "-" + wo_date[0];
      }

      if (this.mode == "Add") {
        this.acdata.wo_no = designdata["wo_no"];
        this.calcAge();
        this.acdata.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
        this.getAuto();
        this.wonoExist(this.acdata.wo_no);
      }

      if (this.mode == "Edit" || this.mode == "View") {
        this.acdata.ref_no = designdata["ac_ref_no"];
        this.acdata.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
        //  this.onEnterWono(this.acdata.wo_no);
        this.getDesignList(this.acdata.ac_id);
      }
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private modalService: BsModalService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private acService: ActualCuttingService
  ) { }
  ngOnInit() {
    if (this.mode == "Add") {
      this.acdata.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //this.acdata.party_code = 'UNIT 1';
      // this.getpartyname(this.acdata.party_code);
      this.getAuto();
    }
    this.tableScroll();
  }

  tableScroll() {
    $(".acbody").height(window.innerHeight - 600);
    $(".acbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    if (this.mode == "Add") {
      setTimeout(() => {
        $("#unit").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#f36-1").focus();
      }, 100);
    }
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      shade = this.designList[ind]["shade"],
      meter = this.designList[ind]["meter"],
      ret_mtr = this.designList[ind]["ret_mtr"],
      retbal_mtr = this.designList[ind]["retbal_mtr"],
      fper = this.designList[ind]["fper"],
      hper = this.designList[ind]["hper"],
      f36 = this.designList[ind].f36,
      f38 = this.designList[ind].f38,
      f40 = this.designList[ind].f40,
      f42 = this.designList[ind].f42,
      f44 = this.designList[ind].f44,
      h36 = this.designList[ind].h36,
      h38 = this.designList[ind].h38,
      h40 = this.designList[ind].h40,
      h42 = this.designList[ind].h42,
      h44 = this.designList[ind].h44,
      totmtrs = this.designList[ind]["totmtrs"];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "meter" && nxtRow.length == 0) {
      let len = this.designList.length;
      let meter = this.designList[len - 1]["meter"];

      nxtInd = nxtInd + 1;
      $("#" + "shade" + "-" + nxtInd).focus();

      if (meter != 0 && nxtInd == len) {
        this.designList.push({
          shade: "",
          meter: 0,
          f36: 0,
          f38: 0,
          f40: 0,
          f42: 0,
          f44: 0,
          f46: 0,
          h36: 0,
          h38: 0,
          h40: 0,
          h42: 0,
          h44: 0,
          h46: 0,
          totmtrs: 0,
          card_no: 0
        });

        $("#" + "meter" + "-" + nxtInd).focus();
      } else if (meter == 0 && nxtInd == len) {
        let a = nxtInd - 1;
        $("#" + "meter" + "-" + a).focus();
      } else {
        $("#" + "meter" + "-" + nxtInd).focus();

        return false;
      }
    } else if (
      fld == "f36" ||
      fld == "f38" ||
      fld == "f40" ||
      fld == "f42" ||
      fld == "f44"
    ) {
      $("#" + fld + "-" + nxtInd).select();
    } else if (
      fld == "h36" ||
      fld == "h38" ||
      fld == "h40" ||
      fld == "h42" ||
      fld == "h44"
    ) {
      $("#" + fld + "-" + nxtInd).select();
    } else if (fld == "item_name") {
      let nxtRowID = nxtRow[0].id;
      nxtInd = nxtRowID.split("-")[1];
    } else {
      setTimeout(() => {
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  getpartyname(code) {
    let params = {
      code: code,
    };
    this.acService.getPartyDet(params).then((res: any) => {
      this.acdata.party_name = res.data[0].party_name;
      this.acdata.party_id = res.data[0].party_id;
    });
  }

  getDesignList(ac_id) {
    let params = {
      ac_id: ac_id,
    };
    this.acService.getEditDesignList(params).then((res: any) => {
      this.designList = res.data;
      //      this.designList = this.designList.concat(res.wodata);
      for (var i = 0; i < this.designList.length; i++) {
        let temp = this.designList[i];
        this.designList[i] = Object.assign(
          {},
          this.designList[i],
          res.wodata[i]
        );
      }
      this.calcGrandTotal();
    });
  }

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  nextSlide() {
    this.currentSlide = false;
  }
  previousSlide() {
    this.currentSlide = true;
  }
  calcTotal(ind) {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };
    for (let i = 0; i < this.designList.length; i++) {
      //ftotalpcs
      this.designList[ind]["ac_ftot"] =
        nan(this.designList[ind]["ac_f36"]) +
        nan(this.designList[ind]["ac_f38"]) +
        nan(this.designList[ind]["ac_f40"]) +
        nan(this.designList[ind]["ac_f42"]) +
        nan(this.designList[ind]["ac_f44"]) +
        nan(this.designList[ind]["ac_f46"]);

      //htotalpcs
      this.designList[ind]["ac_htot"] =
        nan(this.designList[ind]["ac_h36"]) +
        nan(this.designList[ind]["ac_h38"]) +
        nan(this.designList[ind]["ac_h40"]) +
        nan(this.designList[ind]["ac_h42"]) +
        nan(this.designList[ind]["ac_h44"]) +
        nan(this.designList[ind]["ac_h46"]);

      //calccons
      this.designList[ind]["ac_avg_cons"] = (
        nan(this.designList[ind]["mtr"]) /
        (nan(this.designList[ind]["ac_ftot"]) +
          nan(this.designList[ind]["ac_htot"]))
      ).toFixed(2);
      //  this.designList[ind]['ac_havg_cons']= (nan(this.designList[ind]['mtr'])/(nan(this.designList[ind]['ac_ftot'])+nan(this.designList[ind]['ac_htot']))).toFixed(2);

      //calcdiff
      this.designList[ind]["ac_fs_diff"] =
        nan(this.designList[ind]["ac_ftot"]) -
        nan(this.designList[ind]["ftot"]);
      this.designList[ind]["ac_hs_diff"] =
        nan(this.designList[ind]["ac_htot"]) -
        nan(this.designList[ind]["htot"]);

      if (
        nan(this.designList[ind]["ret_mtr"]) > nan(this.designList[ind]["mtr"])
      ) {
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "INVALID DATA",
          body: "Enter Less Than W.O RATIO MTR",
        });
        this.designList[ind]["ret_mtr"] = 0;
      }

      //calc Bal_Ret Mtr
      this.designList[ind]["retbal_mtr"] =
        nan(this.designList[ind]["mtr"]) - nan(this.designList[ind]["ret_mtr"]);

      if (
        nan(this.designList[ind]["meter"]) >
        nan(this.designList[ind]["retbal_mtr"])
      ) {
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "INVALID DATA",
          body: "Enter Less Than W.O RATIO MTR",
        });
        this.designList[ind]["meter"] = 0;
      }

      //calc_ Bal_Bit
      this.designList[ind]["ac_balmtrs"] =
        nan(this.designList[ind]["mtr"]) -
        (nan(this.designList[ind]["ret_mtr"]) +
          nan(this.designList[ind]["meter"]));
    }
    this.calcGrandTotal();
  }
  calcGrandTotal() {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    },
      ret_mtr = 0,
      retbal_mtr = 0,
      meter = 0,
      f36_tot = 0,
      f38_tot = 0,
      f40_tot = 0,
      f42_tot = 0,
      f44_tot = 0,
      f46_tot = 0,
      h36_tot = 0,
      h38_tot = 0,
      h40_tot = 0,
      h42_tot = 0,
      h44_tot = 0,
      h46_tot = 0;
    for (let i = 0; i < this.designList.length; i++) {
      let des = this.designList[i];
      meter = nan(des["meter"]);
      ret_mtr = nan(des["ret_mtr"]);
      retbal_mtr = nan(des["retbal_mtr"]);
      f36_tot += nan(des["ac_f36"]);
      f38_tot += nan(des["ac_f38"]);
      f40_tot += nan(des["ac_f40"]);
      f42_tot += nan(des["ac_f42"]);
      f44_tot += nan(des["ac_f44"]);
      f46_tot += nan(des["ac_f46"]);
      h36_tot += nan(des["ac_h36"]);
      h38_tot += nan(des["ac_h38"]);
      h40_tot += nan(des["ac_h40"]);
      h42_tot += nan(des["ac_h42"]);
      h44_tot += nan(des["ac_h44"]);
      h46_tot += nan(des["ac_h46"]);
    }
    this.acdata["meter"] = meter;
    this.acdata["ret_mtr"] = ret_mtr;
    this.acdata["retbal_mtr"] = retbal_mtr;
    this.acdata["ac_f36_tot"] = f36_tot;
    this.acdata["ac_f38_tot"] = f38_tot;
    this.acdata["ac_f40_tot"] = f40_tot;
    this.acdata["ac_f42_tot"] = f42_tot;
    this.acdata["ac_f44_tot"] = f44_tot;
    this.acdata["ac_f46_tot"] = f46_tot;
    this.acdata["ac_h36_tot"] = h36_tot;
    this.acdata["ac_h38_tot"] = h38_tot;
    this.acdata["ac_h40_tot"] = h40_tot;
    this.acdata["ac_h42_tot"] = h42_tot;
    this.acdata["ac_h44_tot"] = h44_tot;
    this.acdata["ac_h46_tot"] = h46_tot;

    this.acdata["ac_fs_total"] =
      nan(f36_tot) +
      nan(f38_tot) +
      nan(f40_tot) +
      nan(f42_tot) +
      nan(f44_tot) +
      nan(f46_tot);
    this.acdata["ac_hs_total"] =
      nan(h36_tot) +
      nan(h38_tot) +
      nan(h40_tot) +
      nan(h42_tot) +
      nan(h44_tot) +
      nan(h46_tot);

    this.acdata["ac_fh36_tot"] =
      nan(this.acdata["ac_f36_tot"]) + nan(this.acdata["ac_h36_tot"]);
    this.acdata["ac_fh38_tot"] =
      nan(this.acdata["ac_f38_tot"]) + nan(this.acdata["ac_h38_tot"]);
    this.acdata["ac_fh40_tot"] =
      nan(this.acdata["ac_f40_tot"]) + nan(this.acdata["ac_h40_tot"]);
    this.acdata["ac_fh42_tot"] =
      nan(this.acdata["ac_f42_tot"]) + nan(this.acdata["ac_h42_tot"]);
    this.acdata["ac_fh44_tot"] =
      nan(this.acdata["ac_f44_tot"]) + nan(this.acdata["ac_h44_tot"]);
    this.acdata["ac_fh46_tot"] =
      nan(this.acdata["ac_f46_tot"]) + nan(this.acdata["ac_h46_tot"]);
    this.acdata["ac_tot_pcs"] =
      nan(this.acdata["ac_fs_total"]) + nan(this.acdata["ac_hs_total"]);
    this.calcDiff();
  }
  calcDiff() {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    },
      ac_tot_diff = 0;
    for (let i = 0; i < this.designList.length; i++) {
      let des = this.designList[i];
      ac_tot_diff += nan(des["ac_fs_diff"]) + nan(des["ac_hs_diff"]);
    }
    this.acdata["ac_tot_diff"] = ac_tot_diff;
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.designList.length > 1) {
          that.data.designList.splice(ind, 1);

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
        //   that.calcTotal($event,ind);
      },
      function (dismiss) { }
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  wonoExist(wo_no) {
    let params = {
      wo_no: wo_no,
    };

    this.acService.wonoExist(params).then((res: any) => {
      if (res.success) {
        if (res.data.length > 0) {
          let wo_no = res.data[0].wo_no;
          swal(
            "WO No " +
            wo_no +
            " already Exists" +
            ". There is no lump left for cutting"
          );
          this.acdata.wo_no = null;
        }

        this.onEnterWono(this.acdata.wo_no);
      }
    });
  }
  cunoExist(cu_no) {
    let params = {
      ac_no: cu_no,
    };

    this.acService.cunoExist(params).then((res: any) => {
      if (res.success) {
        let ac_no = res.data[0].ac_no;
        swal("Cutting No " + ac_no + " already Exists");
        this.acdata.cu_no = "";
      }
    });
  }
  getAuto() {
    this.acService.getAuto({}).then((res: any) => {
      this.acdata.ref_no = res;
    });
  }

  onEnterWono(wono) {
    if (wono == null) {
      this.acdata.wo_id = "";
      this.acdata.shirt_design = "";
      this.acdata.brand = "";
      this.acdata.style = "";
      this.acdata.fab_design = "";
      this.acdata.sample_no = "";
      this.acdata.wo_date = "";
      this.acdata.width = "";
      this.acdata.age = "";
      this.acdata.ac_f36_tot = "";
      this.acdata.ac_f38_tot = "";
      this.acdata.ac_f40_tot = "";
      this.acdata.ac_f42_tot = "";
      this.acdata.ac_f44_tot = "";
      this.acdata.ac_f46_tot = "";
      this.acdata.ac_h36_tot = "";
      this.acdata.ac_h38_tot = "";
      this.acdata.ac_h40_tot = "";
      this.acdata.ac_h42_tot = "";
      this.acdata.ac_h44_tot = "";
      this.acdata.ac_h46_tot = "";
      this.acdata.ac_fh36_tot = "";
      this.acdata.ac_fh38_tot = "";
      this.acdata.ac_fh40_tot = "";
      this.acdata.ac_fh42_tot = "";
      this.acdata.ac_fh44_tot = "";
      this.acdata.ac_fh46_tot = "";
      this.acdata.ac_fh46_tot = "";
      this.acdata.ac_fs_total = "";
      this.acdata.ac_hs_total = "";
      this.acdata.ac_tot_pcs = "";
      this.acdata.ac_tot_diff = "";
      this.acdata.f36_tot = "";
      this.acdata.f38_tot = "";
      this.acdata.f40_tot = "";
      this.acdata.f42_tot = "";
      this.acdata.f44_tot = "";
      this.acdata.f46_tot = "";
      this.acdata.h36_tot = "";
      this.acdata.h38_tot = "";
      this.acdata.h40_tot = "";
      this.acdata.h42_tot = "";
      this.acdata.h44_tot = "";
      this.acdata.h46_tot = "";
      this.acdata.fh36_tot = "";
      this.acdata.fh38_tot = "";
      this.acdata.fh40_tot = "";
      this.acdata.fh42_tot = "";
      this.acdata.fh44_tot = "";
      this.acdata.fh46_tot = "";
      this.acdata.fh46_tot = "";
      this.acdata.fs_total = "";
      this.acdata.hs_total = "";
      this.acdata.tot_pcs = "";
      this.designList = [
        {
          shade: "",
          meter: 0,
          f36: 0,
          f38: 0,
          f40: 0,
          f42: 0,
          f44: 0,
          f46: 0,
          h36: 0,
          h38: 0,
          h40: 0,
          h42: 0,
          h44: 0,
          h46: 0,
          totmtrs: 0,
          card_no: 0
        },
      ];
    } else {
      let params = {
        wo_no: wono,
      };

      let that = this;
      that.acService.getDesignDetailsList(params).then((res: any) => {
        if (res.data == false) {
          this.acdata.wo_id = "";
          this.acdata.shirt_design = "";
          this.acdata.brand = "";
          this.acdata.style = "";
          this.acdata.fab_design = "";
          this.acdata.sample_no = "";
          this.acdata.wo_date = "";
          this.acdata.cu_date ="";
          this.acdata.cu_no = ""
          this.acdata.width = "";
          this.acdata.age = "";
          this.acdata.ac_f36_tot = "";
          this.acdata.ac_f38_tot = "";
          this.acdata.ac_f40_tot = "";
          this.acdata.ac_f42_tot = "";
          this.acdata.ac_f44_tot = "";
          this.acdata.ac_f46_tot = "";
          this.acdata.ac_h36_tot = "";
          this.acdata.ac_h38_tot = "";
          this.acdata.ac_h40_tot = "";
          this.acdata.ac_h42_tot = "";
          this.acdata.ac_h44_tot = "";
          this.acdata.ac_h46_tot = "";
          this.acdata.ac_fh36_tot = "";
          this.acdata.ac_fh38_tot = "";
          this.acdata.ac_fh40_tot = "";
          this.acdata.ac_fh42_tot = "";
          this.acdata.ac_fh44_tot = "";
          this.acdata.ac_fh46_tot = "";
          this.acdata.ac_fh46_tot = "";
          this.acdata.ac_fs_total = "";
          this.acdata.ac_hs_total = "";
          this.acdata.ac_tot_pcs = "";
          this.acdata.ac_tot_diff = "";
          this.acdata.f36_tot = "";
          this.acdata.f38_tot = "";
          this.acdata.f40_tot = "";
          this.acdata.f42_tot = "";
          this.acdata.f44_tot = "";
          this.acdata.f46_tot = "";
          this.acdata.h36_tot = "";
          this.acdata.h38_tot = "";
          this.acdata.h40_tot = "";
          this.acdata.h42_tot = "";
          this.acdata.h44_tot = "";
          this.acdata.h46_tot = "";
          this.acdata.fh36_tot = "";
          this.acdata.fh38_tot = "";
          this.acdata.fh40_tot = "";
          this.acdata.fh42_tot = "";
          this.acdata.fh44_tot = "";
          this.acdata.fh46_tot = "";
          this.acdata.fh46_tot = "";
          this.acdata.fs_total = "";
          this.acdata.hs_total = "";
          this.acdata.tot_pcs = "";
          this.designList = [
            {
              shade: "",
              meter: 0,
              f36: 0,
              f38: 0,
              f40: 0,
              f42: 0,
              f44: 0,
              f46: 0,
              h36: 0,
              h38: 0,
              h40: 0,
              h42: 0,
              h44: 0,
              h46: 0,
              totmtrs: 0,
              card_no: 0
            },
          ];
          if (res.message) {
            swal(res.message);
          }
        } else {
          that.acdata.wo_id = res.data.wo_id;
          that.acdata.shirt_design = res.data.shirt_design_no;
          that.acdata.brand = res.data.brand;
          that.acdata.style = res.data.style;
          that.acdata.fab_design = res.data.fab_design;
          that.acdata.sample_no = res.data.sample_no;
          that.acdata.wo_date = res.data.wo_date;
          that.acdata.cu_date = res.data.cp_date;
          that.acdata.cu_no = res.data.cu_no;
          that.acdata.width = res.data.width;
          that.acdata.fh36_tot = res.data.fh36_tot;
          that.acdata.fh38_tot = res.data.fh38_tot;
          that.acdata.fh40_tot = res.data.fh40_tot;
          that.acdata.fh42_tot = res.data.fh42_tot;
          that.acdata.fh44_tot = res.data.fh44_tot;
          that.acdata.fh46_tot = res.data.fh46_tot;
          that.acdata.fs_total = res.data.fs_total;
          that.acdata.hs_total = res.data.hs_total;
          that.acdata.tot_pcs = res.data.tot_pcs;
          that.designList = res.list;
          let auto_no = res.card_no.auto_no;
          let f36_tot = 0,
            f38_tot = 0,
            f40_tot = 0,
            f42_tot = 0,
            f44_tot = 0,
            f46_tot = 0,
            h36_tot = 0,
            h38_tot = 0,
            h40_tot = 0,
            h42_tot = 0,
            h44_tot = 0,
            h46_tot = 0;

          let color_check = [];

          let run_no = 0;
          that.designList.forEach(el => {
            const ind = color_check.findIndex(x => x === el.shade)
            if (ind === -1) {
            color_check.push(el.shade);
              console.log(color_check);
             el.card_no = auto_no++
             run_no = el.card_no;
            }
             else{
              el.card_no  = run_no;
            }

          });
          console.log(that.designList);
          for (let i = 0; i < res.list.length; i++) {
            let des = res.list[i];
            f36_tot += des.f36;
            f38_tot += des.f38;
            f40_tot += des.f40;
            f42_tot += des.f42;
            f44_tot += des.f44;
            f46_tot += des.f46;
            h36_tot += des.h36;
            h38_tot += des.h38;
            h40_tot += des.h40;
            h42_tot += des.h42;
            h44_tot += des.h44;
            h46_tot += des.h46;

          }
          this.acdata["f36_tot"] = f36_tot;
          this.acdata["f38_tot"] = f38_tot;
          this.acdata["f40_tot"] = f40_tot;
          this.acdata["f42_tot"] = f42_tot;
          this.acdata["f44_tot"] = f44_tot;
          this.acdata["f46_tot"] = f46_tot;
          this.acdata["h36_tot"] = h36_tot;
          this.acdata["h38_tot"] = h38_tot;
          this.acdata["h40_tot"] = h40_tot;
          this.acdata["h42_tot"] = h42_tot;
          this.acdata["h44_tot"] = h44_tot;
          this.acdata["h46_tot"] = h46_tot;
        }
      });
    }
  }
  bsModalRef: BsModalRef;
  printCutting(row) {
    let params = row;
    this.acService.printCutting(params).then((res: any) => {
      this.printData = res;

      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printcontent = this.printData;
    });
  }
  calcAge() {
    let date1 = new Date(this.acdata.wo_date);
    let date2 = new Date(this.acdata.cu_date);
    let diffDays = 0;
    this.acdata["age"] = (date2.getTime() - date1.getTime()) / 86400000;
  }

  onSelectItem($event, design, ind) {
    let design_no = _.filter(this.data.designList, {
      design_no: design.design_no,
      shade: design.shade,
    });

    if (design_no.length == 1) {
      this.onGoToNextFld($event, "quality", ind);
    } else {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "ALREADY EXISTS",
        body: "Design with this shade Already Exists",
      });
      design.design_no = "";
      design.shade = "";
    }
  }

  oncheckemptyrow() {
    let design = this.designList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].shade != "") {
        desList.push(design[i]);
      }
    }
    this.designList = desList;
    this.onSaveOrder();
  }

  onSaveOrder(): void {
    let lump_check = true;

    for (let i = 0; i < this.designList.length; i++) {
      if (this.designList[i].meter <= 0) {
        lump_check = false;
      }
    }
    if (
      this.acdata.wo_no == undefined ||
      this.acdata.cu_no == undefined ||
      this.acdata.cu_date == undefined ||
      this.acdata.unit == undefined
    ) {
      swal("Make sure that all the details are given!! ");
    }

    else if (!lump_check) {
      swal("Make sure that Valid MTR given!! ");
    }

    else {
      let params: any = Object.assign({}, this.acdata);
      params["tabevent"] = undefined;
      params["data"] = JSON.stringify(this.designList);

      params["date"] = this.datePipe.transform(params["date"], "yyyy-MM-dd");
      let that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this Cutting Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.acService
          .saveOrder(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              params["ac_id"] = res.ac_id;
              that.printCutting(params);
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/actualcutting/addEditActualCutting.ts